<template>
    <div class="loader" :style="{ width: width + 'px', height: height + 'px' }">
    </div>
</template>

<script>
    export default {
      props: {
          width: { type: Number, required: false, default: 100 },
          height: { type: Number, required: false, default: 100 }
      }
    }
</script>

<style lang="scss">
    .loader {
        border: 4px solid #dddddd;
        border-top: 4px solid #666666;
        border-right: 4px solid #666666;
        border-left: 4px solid #666666;
        border-radius: 50%;
        margin: 20px auto;
        animation: spin 1.5s linear infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>